if (!customElements.get('product-form-component')) {
    class productFormComponent extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.formSubmitButton = this.querySelector(`button[form="${this.dataset.formId}"]`);
            this.productData = JSON.parse(this.querySelector('.product-option-json').textContent);
            this.productHandle = this.productData.handle;
            this.hasFreeProduct = this.hasAttribute('data-has-free-product');
            this.isAnytimeLink = this.hasAttribute('data-onetime-link');

            this.subscriptionSelector = this.querySelector('subscription-selector');
            this.init();


            // subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
            //     // Always call updateServing regardless of quantity value
            //     this.changeIdOnVariantChange(event);
            // });
        }

        init() {

            this.oneTimeSelectionCheck();
            const _this = this;

            if (this.form) {
                this.form.addEventListener('submit', async (e) => {
                    e.preventDefault();

                    // Get selected selling plan
                    const sellingPlanInput = _this.querySelector('input[name="selling_plan"]:checked') || _this.querySelector('input[name="selling_plan"]');
                    const sellingPlan = sellingPlanInput && sellingPlanInput.value !== '' ? sellingPlanInput.value : null;


                    // Collect all items using FormData
                    const items = this.collectItemsFromFormData();

                    // Add selling plan to each item if selected
                    if (sellingPlan) {
                        items.forEach(item => {
                            if (item.quantity > 0) {
                                item.selling_plan = sellingPlan;
                            }
                        });
                    }

                    // Filter out items with null id
                    const validItems = items.filter(item => item.id !== null);

                    this.formSubmitButton.setAttribute('aria-disabled', true);
                    this.formSubmitButton.classList.add('loading');
                    this.formSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');

                    // Build payload with proper section handling
                    const payload = _this.cart ? { items: validItems, sections: _this.cart.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname } : { items: validItems };

                    // Submit to Shopify
                    fetch(window.Shopify.routes.root + `cart/add.js`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json' // important!
                        },
                        body: JSON.stringify(payload)
                    })
                        .then(response => {
                            console.log('Cart response:', response);
                            if (!response.ok) throw new Error('Failed to add to cart');
                            return response.json(); // this includes `sections` key
                        })
                        .then((response) => {
                            console.log('Cart response:', response);
                            _this.cart.classList.toggle('is-empty', response.item_count === 0);
                            _this.cart.renderContents(response);
                        }).catch((error) => {
                            console.error('Cart error:', error);
                        }).finally(() => {
                            _this.formSubmitButton.removeAttribute('aria-disabled');
                            _this.formSubmitButton.classList.remove('loading');
                            _this.formSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
                        });
                });
            }
        }

        oneTimeSelectionCheck() {
            if (!this.subscriptionSelector) return;
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('product-type')) {
                const value = urlParams.get('product-type');
                if (value === 'one-time') {
                    console.log('works')
                    this.subscriptionSelector.querySelector('label[for="selling_plan_onetime"]').click();
                }
            }
        }

        collectItemsFromFormData() {
            const formData = new FormData(this.form);
            const items = [];
            const itemMap = new Map();

            // First pass: collect all item keys
            for (const key of formData.keys()) {
                const match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
                if (match) {
                    const index = match[1];
                    const field = match[2];

                    if (!itemMap.has(index)) {
                        itemMap.set(index, {});
                    }

                    itemMap.get(index)[field] = formData.get(key);
                }
            }

            // Second pass: build items array
            for (const [index, item] of itemMap.entries()) {
                const quantity = parseInt(item.quantity) || 0;
                if (quantity > 0) {
                    items.push({
                        id: item.id,
                        quantity: quantity
                    });
                }
            }

            return items;
        }
    }


    customElements.define('product-form-component', productFormComponent);
}

if (!customElements.get('variant-quantity-radio')) {
    class VariantQuantityRadio extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', this.handleClick.bind(this));
        }

        connectedCallback() {
            this.subscriptionSelectorUnsubscriber = subscribe('subscription-input-change', (event) => {
                // Always call updateServing regardless of quantity value
                this.updatePerServing(event);
            });
        }

        disconnectedCallback() {
            if (this.subscriptionSelectorUnsubscriber) {
                this.subscriptionSelectorUnsubscriber();
            }
        }


        updatePerServing(data) {
            const servings = this.querySelectorAll('[data-quantity-servings]');
            console.log('Selected input value for per serving update:', data.value);

            if (!servings) return;

            servings.forEach((item) => {
                const quantity = Number(item.querySelector('.quantity-option__input').value) || 1;
                const discount = item.dataset.discountPercent || 0;
                const onetimePrice = item.dataset.oneTimePrice * quantity;
                const subscribePrice = item.dataset.subscribePrice * quantity;
                const baseServings = parseInt(item.getAttribute('data-quantity-servings')) || 0;
                const perServingContainer = item.querySelector('[data-quantity-per-serving]');

                const discountMultiplier = discount ? (100 - discount) / 100 : 1;
                const finalOnetimePrice = ((onetimePrice * discountMultiplier) / baseServings).toFixed(2);
                const finalSubscribePrice = ((subscribePrice * discountMultiplier) / baseServings).toFixed(2);

                if (!perServingContainer) return;

                if (data.value === '') {
                    console.log(baseServings, quantity, onetimePrice)
                    perServingContainer.textContent = finalOnetimePrice;
                } else {
                    console.log(baseServings, quantity, subscribePrice)
                    perServingContainer.textContent = finalSubscribePrice;
                }
            });

            this.pubSubFunction();
        }

        handleClick(e) {
            const _this = this;
            this.selectedInput = this.querySelector('.quantity-option__input:checked').value;

            if (!this.selectedInput) return;

            this.pubSubFunction();
        }

        pubSubFunction() {
            this.selectedInput = this.querySelector('.quantity-option__input:checked');
            this.selectedInputLabel = this.querySelector('label:has(.quantity-option__input:checked)');

            const quantity = parseInt(this.selectedInput.value) || 0;
            const oneTimePrice = this.selectedInputLabel.dataset.oneTimePrice * quantity;
            const subscribePrice = this.selectedInputLabel.dataset.subscribePrice * quantity;
            const container = this.closest('product-form-component');

            const discountPercent = this.querySelector('.quantity-option:has(.quantity-option__input:checked)').dataset.discountPercent;


            let data = {
                quantity,
                oneTimePrice,
                subscribePrice,
                container,
                discountPercent: discountPercent || 0
            };

            // Always publish the event, even when quantity is 0
            publish('variant-quantity-change', data);
        }
    }

    customElements.define('variant-quantity-radio', VariantQuantityRadio);
}

if (!customElements.get('subscription-selector')) {
    class subscriptionSelector extends HTMLElement {
        constructor() {
            super();
            this.servingSize = this.getAttribute('data-serving-size');
            this.productData = JSON.parse(this.closest('section').querySelector('.product-option-json').textContent);
            this.onetimePrice = this.querySelector('[data-onetime-total-price]');
            this.subscribePrice = this.querySelector('[data-subscribe-total-price]');

            this.addEventListener('change', (e) => {
                if (e.target.matches('input[type="radio"]')) {
                    const selectedValue = this.querySelector('input[type="radio"]:checked').value;
                    let data = {
                        value: selectedValue || '',
                        container: this.closest('product-form-component')
                    }

                    publish('subscription-input-change', data);
                }
            });

        }

        variantQuantityUnsubscriber = undefined;

        connectedCallback() {
            this.variantQuantityUnsubscriber = subscribe('variant-quantity-change', (event) => {
                // Always call updateServing regardless of quantity value
                this.updatePricing(event);
            });

            // Default to subscribe option as checked
            const subscribeInput = this.querySelector('.featured-product-option-text-subscribe input');
            subscribeInput.checked = true;
            subscribeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        disconnectedCallback() {
            if (this.variantQuantityUnsubscriber) {
                this.variantQuantityUnsubscriber();
            }
        }

        updatePricing(event) {
            console.log(event);
            const qty = event.quantity;
            const discount = event.discountPercent;
            const discountMultiplier = discount != 0 ? (100 - discount) / 100 : 1;

            const oneTimePrice = (event.oneTimePrice * discountMultiplier) || ((this.productData['each_price_onetime'] * qty) * discountMultiplier);
            const subscribePrice = (event.subscribePrice * discountMultiplier) || ((this.productData['each_price_subscribe'] * qty) * discountMultiplier);

            // console.log('Updating pricing with qty:', qty, 'eachPriceOnetime:', oneTimePrice, 'eachPriceSubscribe:', subscribePrice, 'discount:', discount);

            if (this.onetimePrice) {
                this.onetimePrice.textContent = oneTimePrice.toFixed(2);
            }

            if (this.subscribePrice) {
                console.log('works');
                this.subscribePrice.textContent = subscribePrice.toFixed(2);
            }

            this.updateServing(event.quantity, oneTimePrice, subscribePrice);
        }

        updateServing(quantity, onetimePrice, subscribePrice) {
            if (!quantity || !onetimePrice || !subscribePrice) return;

            const inputLabels = this.querySelectorAll('label');
            const totalServingContainers = this.querySelectorAll('[data-servings]');

            console.log(totalServingContainers);

            if (totalServingContainers.length > 0) {
                totalServingContainers.forEach((container) => {
                    return container.textContent = this.servingSize * quantity;
                });
            }

            if (inputLabels) {
                inputLabels.forEach((label) => {
                    if (quantity === 0) return

                    const oneTimeServingContainer = label.querySelector('[data-one-time-serving]');
                    const subscribeServingContainer = label.querySelector('[data-subscribe-per-serving]');

                    // console.log('eachPriceOnetime:', onetimePrice, 'eachPriceSubscribe:', subscribePrice, 'servingSize:', this.servingSize);

                    if (oneTimeServingContainer) oneTimeServingContainer.textContent = (onetimePrice / (this.servingSize * quantity)).toFixed(2);

                    if (subscribeServingContainer) subscribeServingContainer.textContent = (subscribePrice / (this.servingSize * quantity)).toFixed(2);
                });
            }
        }
    }

    customElements.define('subscription-selector', subscriptionSelector);
}

if (!customElements.get('subscription-selector')) {
    class UpsellProducts extends HTMLElement {
        constructor() {
            super();
            this.slider;
            this.upsellSlider = this.querySelector('.upsell-slider');

            this.initSlider();

        }

        initSlider() {
            const sliderConfig = {
                slides: {
                    perView: 'auto',
                    spacing: 10
                }
            }
            this.slider = new KeenSlider(this.upsellSlider, sliderConfig);
        }
    }

    customElements.define('upsell-products', UpsellProducts);
}


if (!customElements.get('cart-reviews-slider')) {
    class CartReviewsSlider extends HTMLElement {
        constructor() {
            super();
            this.slider = null;
            this.sliderEl = this.querySelector('[data-cart-reviews-slider]');
            this.dotsEl = this.querySelector('[data-cart-reviews-dots]');
        }

        connectedCallback() {
            if (!this.sliderEl) return;

            if (typeof KeenSlider === 'undefined') {
                setTimeout(() => this.connectedCallback(), 100);
                return;
            }

            if (this.slider) return;

            this.slider = new KeenSlider(this.sliderEl, {
                loop: true,
                mode: 'snap',
                slides: { perView: 1, spacing: 10 },
                created: (slider) => {
                    this.updateDots(slider.track.details.rel);
                    this.attachDotHandlers(slider);
                },
                slideChanged: (slider) => {
                    this.updateDots(slider.track.details.rel);
                },
            });
        }

        disconnectedCallback() {
            if (this.slider) {
                this.slider.destroy();
                this.slider = null;
            }
        }

        updateDots(activeIdx) {
            if (!this.dotsEl) return;

            const dots = this.dotsEl.querySelectorAll('[data-dot]');
            dots.forEach((dot) => {
                const idx = parseInt(dot.getAttribute('data-dot') || '0', 10);
                dot.setAttribute('aria-current', idx === activeIdx ? 'true' : 'false');
            });
        }

        attachDotHandlers(slider) {
            if (!this.dotsEl) return;
            if (this.dotsEl.hasAttribute('data-dots-bound')) return;

            this.dotsEl.setAttribute('data-dots-bound', 'true');
            this.dotsEl.addEventListener('click', (e) => {
                const btn = e.target.closest('[data-dot]');
                if (!btn) return;
                const idx = parseInt(btn.getAttribute('data-dot') || '0', 10);
                slider.moveToIdx(idx);
            });
        }
    }

    customElements.define('cart-reviews-slider', CartReviewsSlider);
}

if (!customElements.get('variant-quantity-controls')) {
    class VariantQuantityControls extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', this.handleClick.bind(this));
            this.onloadInput();
        }

        disconnectedCallback() {
            this.onloadInput();
        }

        handleClick(e) {
            const _this = this;
            const button = e.target.closest('.quantity-minus, .quantity-plus');
            if (!button) return;

            const isMinus = button.classList.contains('quantity-minus');
            const container = button.closest('.quantity-selector');
            if (!container) return;

            const visibleInput = container.querySelector('.quantity-input');
            const hiddenInput = container.querySelector('input[type="hidden"][name*="[quantity]"]');

            if (!visibleInput || !hiddenInput) {
                console.error('Inputs not found in container:', container);
                return;
            }

            // Update current input value
            const currentValue = parseInt(visibleInput.value) || 0;
            const newValue = Math.max(0, currentValue + (isMinus ? -1 : 1));
            visibleInput.value = newValue.toString();
            hiddenInput.value = newValue.toString();

            // Calculate total quantity
            const totalQuantity = this.allQuantity();

            // Always publish the event, even when quantity is 0
            publish('variant-quantity-change', { quantity: totalQuantity, container: this.closest('product-form-component') });

            console.log(`Quantity updated to ${newValue} in container:`, container);
            console.log(`Total quantity: ${totalQuantity}`);
        }

        allQuantity() {
            const allQuantityInputs = this.closest('form').querySelectorAll('.quantity-input');
            let totalQuantity = 0;
            allQuantityInputs.forEach(input => {
                totalQuantity += parseInt(input.value) || 0;
            });
            return totalQuantity;
        }
    }

    customElements.define('variant-quantity-controls', VariantQuantityControls);
}

if (!customElements.get('product-price-switcher')) {
    class ProductPriceSwitcher extends HTMLElement {
        constructor() {
            super();
            this.productData = JSON.parse(this.querySelector('.product-option-json').textContent);
            this.dataPriceAll = this.querySelectorAll('[data-price]');
            this.currencySymbol = this.getAttribute('data-currency-symbol');
        }

        variantQuantityUnsubscriber = undefined;

        connectedCallback() {
            this.variantQuantityUnsubscriber = subscribe('variant-quantity-change', (event) => {
                // Always call updateServing regardless of quantity value
                this.updatePricing(event.quantity, event.container);
            });
        }

        disconnectedCallback() {
            if (this.variantQuantityUnsubscriber) {
                this.variantQuantityUnsubscriber();
            }
        }

        updatePricing(qty, container) {
            const _this = this;
            const dataPriceBlock = container.querySelector('[data-price-block]');
            if (qty === 0) {
                dataPriceBlock.querySelector('[data-empty-text]').classList.remove('hide');
                dataPriceBlock.querySelectorAll('[data-price]').forEach((price) => {
                    price.classList.add('hide');
                });
                return;
            }

            dataPriceBlock.querySelector('[data-empty-text]').classList.add('hide');
            dataPriceBlock.querySelectorAll('[data-price]').forEach((price) => {
                price.classList.remove('hide');
            });

            if (dataPriceBlock.hasAttribute('data-onetime')) {
                dataPriceBlock.querySelector('[data-regular-price]').textContent = _this.currencySymbol + (_this.productData['each_price_onetime'] * qty).toFixed(2);
            } else {
                dataPriceBlock.querySelector('[data-compare-price]').textContent = _this.currencySymbol + (_this.productData['full_price_subscribe'] * qty).toFixed(2);
                dataPriceBlock.querySelector('[data-regular-price]').textContent = _this.currencySymbol + (_this.productData['each_price_subscribe'] * qty).toFixed(2);
                dataPriceBlock.querySelector('[data-save-price]').textContent = _this.currencySymbol + Math.round((_this.productData['full_price_subscribe'] - _this.productData['each_price_subscribe']) * qty);
            }
        }
    }

    customElements.define('product-price-switcher', ProductPriceSwitcher);
}


if (!customElements.get('direct-to-checkout')) {
    class directToCheckout extends HTMLElement {
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.parentFormComponent = this.closest('product-form-component');
            this.onetimePrice = this.querySelectorAll('[data-onetime-price]');
            this.items = this.parentFormComponent.collectItemsFromFormData();
            this.init();
        }

        variantQuantityUnsubscriber = undefined;

        connectedCallback() {
            this.variantQuantityUnsubscriber = subscribe('variant-quantity-change', (event) => {
                // Always call updateServing regardless of quantity value
                this.updatePricing(event.quantity);
            });
        }

        disconnectedCallback() {
            if (this.variantQuantityUnsubscriber) {
                this.variantQuantityUnsubscriber();
            }
        }

        updatePricing(qty) {
            const eachPriceOnetime = this.parentFormComponent.productData['each_price_onetime'];
            const currencySymbol = this.parentFormComponent.productData['currency_symbol'];

            if (qty === 0) {
                if (this.onetimePrice.length > 0) {
                    this.onetimePrice.forEach((price) => {
                        price.textContent = currencySymbol + (eachPriceOnetime * 1).toFixed(2);
                    });
                }
                return;
            }

            if (this.onetimePrice.length > 0) {
                this.onetimePrice.forEach((price) => {
                    price.textContent = currencySymbol + (eachPriceOnetime * qty).toFixed(2);
                });
            }
        }

        init() {
            const _this = this;
            this.form.addEventListener('submit', async (e) => {
                e.preventDefault();

                this.items = this.parentFormComponent.collectItemsFromFormData();

                if (this.items.length === 0) {
                    return;
                }

                // Build cart items string in Shopify's format
                const cartItems = this.items.map(item =>
                    `${item.id}:${item.quantity}`
                ).join(',');

                // Build checkout URL
                const baseUrl = window.Shopify.routes.root || '/';
                const checkoutUrl = `${baseUrl}cart/${cartItems}?checkout`;

                // Verify URL before redirect
                console.log('Redirecting to:', checkoutUrl);

                // Redirect immediately
                window.location.href = checkoutUrl;
            })
        }
    }

    customElements.define('direct-to-checkout', directToCheckout);
}